import { Controller } from "stimulus"
import  axios from 'axios'; 
export default class extends Controller {
  static get targets(){
    return ['name', 'sourcePartNumber', 'model'];
  }

  initialize() {
    this.lookupProduct = _.debounce(this.lookupProduct, 500);
  }

  connect(){
    const csrfToken = document.querySelector("meta[name=csrf-token]").content
    axios.defaults.headers.common['X-CSRF-Token'] = csrfToken
    axios.defaults.headers.common['Accept'] = 'application/json';
  }

  lookupProduct(e) {
    const barcode = e.target.value;
    let t = this; 
    if (t.errorMessage) {
      t.errorMessage.remove(); 
    }
    if (barcode.trim().length > 0)   {
    axios.get('/rmrc_ad/products_by_barcode/' + barcode).then(function(response){
      t.nameTarget.value = response.data.name;
      t.sourcePartNumberTarget.value = response.data.source_part_number; 
      t.modelTarget.value = response.data.model; 
    }).catch(function(err){
      t.errorMessage = document.createElement('p'); 
      t.errorMessage.style.color = 'red'; 
      t.errorMessage.innerHTML = 'Unable to find this product';
      e.target.after(t.errorMessage)
     }) 
    }
  }

}



// WEBPACK FOOTER //
// ./app/javascript/rmrc_ad/controllers/copy_product_controller.js